import {
  OrderAcquisitionType,
  ShipmentStopType,
  ShipmentType,
  StopCreateInput,
} from "@api/graphql/generated/generated-types";
import { CreateOrderFormData } from "../types";
import { getCourierTodayForDatePicker } from "@src/common/utils/timezoneConverters";
import { EMPTY_RETURN_LEG } from "./returnLeg";

export const GetOneOffOrderDefaultValues = (): CreateOrderFormData => {
  const shipmentDate = getCourierTodayForDatePicker();
  return {
    acquisitionType: OrderAcquisitionType.User,
    caller: "",
    callerPhone: "",
    costCenterId: "",
    courierId: "",
    endCustomerId: "",
    endCustomerReferenceNumber: "",
    notes: "",
    orderTypeId: "2",
    shipments: [
      {
        shipmentDate: shipmentDate,
        stops: [
          {
            city: "",
            contactName: "",
            companyName: "",
            country: "",
            googlePlaceId: "",
            instruction: "",
            phone: "",
            state: "",
            stopTemplateId: "",
            streetAddress: "",
            suite: "",
            timeWindow: {
              open: null,
              close: null,
            },
            type: ShipmentStopType.PickUp,
          },
          {
            city: "",
            contactName: "",
            companyName: "",
            country: "",
            googlePlaceId: "",
            instruction: "",
            phone: "",
            state: "",
            stopTemplateId: "",
            streetAddress: "",
            suite: "",
            timeWindow: {
              open: null,
              close: null,
            },
            type: ShipmentStopType.DropOff,
          },
        ],
        type: ShipmentType.Simple,
        packageSize: undefined,
        packageWeightInPounds: undefined,
        packageTypeId: undefined,
        vehicleTypeId: undefined,
        numPackages: undefined,
        packageDescription: undefined,
        // The base package row is always present, so it is seeded rather than added.
        // Empty on purpose: a lone dimensionless row is not a package item on submit.
        packageItems: [{}],
      },
    ],
    returnLeg: { ...EMPTY_RETURN_LEG },
  };
};

export const defaultStopFormValues: StopCreateInput = {
  city: "",
  contactName: "",
  country: "",
  googlePlaceId: "",
  instruction: "",
  phone: "",
  state: "",
  stopTemplateId: "",
  streetAddress: "",
  suite: "",
  timeWindow: {
    open: null,
    close: null,
  },
  type: ShipmentStopType.DropOff,
};

export const defaultStopTemplateFormValues = {
  companyName: "",
  contactName: "",
  googlePlaceId: "",
  instruction: "",
  phone: "",
  suite: "",
  streetAddress: "",
  timeWindow: {
    openSecondsSinceMidnightUtc: null,
    closeSecondsSinceMidnightUtc: null,
  },
  type: ShipmentStopType.DropOff,
};
